
import { sites } from '../helpers/globalVariables';

const isTHD = window.globalConfig.siteId === sites.theHomeDepot;

export { default as ToCurrency } from './currency';

export const mandiPhoneNum = '1-877-865-9871';
export const onlineOriginPhoneNum = '1-800-340-2850';
export const inStoreOriginPhoneNum = '1-800-340-2850';
export const cecOriginPhoneNum = '1-877-865-9871';

// when origin is unknown
export const defaultPhoneNum = isTHD ? '1-877-865-9871' : window.globalConfig.contactNumber;

export const getPhoneNumber = (originMODE) => {
  const url = window.location.href;
  if (originMODE === 'InStore') {
    return inStoreOriginPhoneNum;
  } else if (originMODE === 'Online') {
    return onlineOriginPhoneNum;
  } else if (url.indexOf('summary') !== -1) {
    return inStoreOriginPhoneNum;
  }
  return defaultPhoneNum;
};
